<template>
  <div id="user-list">
    <!-- app drawer -->
    <v-dialog
      v-model="isFormActive"
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 500 : '100%'"
    >
      <isbn-form
        v-model="item"
        :is-form-active="isFormActive"
        @refetch-data="fetchItems"
      >
        <template v-slot:form-title>
          <span class="font-weight-semibold text-base text--primary">{{ item.id ? $t('Modifier'): $t('Ajouter un ISBN') }}</span>
          <v-spacer />
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="isFormActive = !isFormActive"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </template>
        <template v-slot:form-cancel>
          <v-btn
            :loading="loading"
            color="secondary"
            outlined
            @click="isFormActive = !isFormActive"
          >
            {{ $t('Annuler') }}
          </v-btn>
        </template>
      </isbn-form>
    </v-dialog>
    <v-dialog
      v-model="isFormMultipleActive"
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 500 : '100%'"
    >
      <isbn-multiple-form
        v-model="item"
        :is-form-active="isFormMultipleActive"
        @refetch-data="fetchItems"
      >
        <template v-slot:form-title>
          <span class="font-weight-semibold text-base text--primary">{{ $t('Importer des ISBN') }}</span>
          <v-spacer />
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="isFormMultipleActive = !isFormMultipleActive"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </template>
      </isbn-multiple-form>
    </v-dialog>
    <!-- isbn total card -->

    <!-- list filters -->
    <v-card>
      <v-card-title>
        {{ $t("ISBN Numeriques") }}<v-chip
          outlined
          class="ml-2"
        >
          {{ totalItems }}
        </v-chip>
        <v-spacer />
        <export-excel
          :options="downloadObject"
          title="Export ISBN"
          @refetch-data="fetchItems"
        />
        <v-btn
          color="primary"
          depressed
          outlined
          class=" me-2"
          @click="openMultipleDialog()"
        >
          {{ $t('Importer des ISBN') }}
        </v-btn>
        <v-btn
          color="primary"
          class=""
          depressed
          @click="openDialog()"
        >
          {{ $t('Ajouter un ISBN') }}
        </v-btn>
      </v-card-title>

      <!-- table -->
      <v-data-table
        v-model="selectedRows"
        class="fixed-table"
        fixed-header
        :height="tableHeight"
        dense
        :headers="filters"
        :items="items"
        :options.sync="options"
        :page.sync="page"
        :server-items-length="totalItems"
        :loading="loading"
        :loading-text="$t('Chargement des éléments')"
        :no-data-text="$t('Pas de données')"
        :no-results-text="$t('Aucun résultat')"
        hide-default-footer
        :show-select="false"
        @page-count="pageCount = $event"
      >
        <template #body.prepend="{ items, headers }">
          <header-filters :headers="filters" />
        </template>
        <!-- actions -->
        <template #[`item.actions`]="{item}">
<!--          <v-btn
            icon
            small
          >
            <v-icon
              size="20"
              @click="openDialog(item)"
            >
              {{ icons.mdiPencilOutline }}
            </v-icon>
          </v-btn>-->
          <v-btn
            v-if="item.type == null"
            small
            color="error"
            @click="confirmDelete(item)"
          >

            {{ $t("Supprimer") }}
          </v-btn>
        </template>
        <template #[`item.type`]="{item}">
          <span v-if="item.type === 2">Broché</span>
          <span v-else-if="item.type === 1">Numerique</span>
          <span v-else>Inutilisé</span>
        </template>
        <template #[`item.type`]="{item}">
          <span @click="copy(item.isbn)">{{ item.isbn }}</span>
        </template>
        <template #[`item.parution`]="{ item }">
          <span>{{ formatDate(item.parution || null, { month: 'numeric', day: 'numeric', year: 'numeric' }) }}</span>
        </template>
      </v-data-table>
      <v-card-text class="pt-2">
        <v-row>
          <v-col
            lg="2"
            cols="3"
          >
            <rows-per-page :options="options" />
          </v-col>

          <v-col
            lg="10"
            cols="9"
            class="d-flex justify-end"
          >
            <v-pagination
              v-model="page"
              total-visible="6"
              :length="pageCount"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="deleteDialog"
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 300 : '100%'"
    >
      <v-card>
        <v-card-title>{{ $t("Confirmer la suppression") }}</v-card-title>
        <v-divider />
        <v-card-text v-if="item && item.id">{{ $t("Confirmez-vous de vouloir supprimer") }}: {{ item.isbn }}</v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            small
            outlined
            @click="deleteDialog = false"
          >
            {{ $t("Non") }}
          </v-btn>
          <v-spacer />
          <v-btn
            :loading="loading"
            small
            color="primary"
            @click="deleteItem"
          >
            {{ $t("Oui") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="isSnackbarBottomVisible"
      :color="$vuetify.theme.currentTheme.error"
      :light="$vuetify.theme.dark"
    >
      {{ snackBarMessage }}
    </v-snackbar>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiSquareEditOutline,
  mdiDotsVertical,
  mdiPlus,
  mdiClose,
  mdiFileDocumentOutline,
  mdiDeleteOutline,
  mdiExportVariant,
  mdiAccountOutline,
  mdiPencilOutline,
} from '@mdi/js'
import { onUnmounted, ref, watch } from '@vue/composition-api'

// sidebar
import { avatarText, formatDate } from '@core/utils/filter'
import axios from '@axios'
import store from '@/store'
import IsbnForm from './IsbnForm.vue'
import userStoreModule from './itemStoreModule'

import controller from './Controller'
import RowsPerPage from '@/components/RowsPerPage'
import itemStoreModule from '@/views/apps/publications/itemStoreModule'
import HeaderFilters from '@/components/HeaderFilters'
import IsbnMultipleForm from '@/views/apps/isbns/IsbnMultipleForm'
import ExportExcel from '@/components/ExportExcel'

export default {
  components: {
    ExportExcel,
    IsbnMultipleForm,
    HeaderFilters,
    RowsPerPage,
    IsbnForm,
  },
  setup() {
    const APP_STORE_MODULE_NAME = 'isbn'
    const superiors = ref([])
    const assistants = ref([])

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME)) store.registerModule(APP_STORE_MODULE_NAME, userStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME)) store.unregisterModule(APP_STORE_MODULE_NAME)
    })

    const USER_APP_STORE_PUBLICATION_MODULE_NAME = 'app-publication'

    // Register module
    if (!store.hasModule(USER_APP_STORE_PUBLICATION_MODULE_NAME)) store.registerModule(USER_APP_STORE_PUBLICATION_MODULE_NAME, itemStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_PUBLICATION_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_PUBLICATION_MODULE_NAME)
    })

    const {
      item,
      items,
      tableColumns,
      searchQuery,
      totalItems,
      loading,
      options,
      selectedRows,
      isFormActive,
      isFormMultipleActive,
      snackBarMessage,
      isSnackbarBottomVisible,
      openDialog,
      openMultipleDialog,
      downloadObject,
      deleteItem,
      confirmDelete,
      deleteDialog,
      fetchItems,
      filters,
    } = controller()

    axios
      .get('/listWorkers', {
        params: {
          term: '',
          rowsPerPage: 100,
          user: JSON.parse(localStorage.getItem('userData')).id || null,
        },
      })
      .then(response => {
        for (let i = 0; i < response.data.length; i++) {
          const u = response.data[i]
          const indexU = assistants.value.findIndex(el => el.id === u.id)
          if (indexU < 0) {
            assistants.value.push(u)
          }
        }
        const indexH = filters.value.findIndex(ele => ele.value === 'assistant.code')
        if (indexH > 0) {
          filters.value[indexH].filter.values = assistants.value.filter(el => el.role_name === 'assistant_indirect')
        }
        const indexC = filters.value.findIndex(ele => ele.value === 'assistant_cover.code')
        if (indexC > 0) {
          filters.value[indexC].filter.values = assistants.value.filter(el => el.role_name === 'assistant_indirect')
        }
        const indexGest = filters.value.findIndex(ele => ele.value === 'gestion.code')
        if (indexGest > 0) {
          filters.value[indexGest].filter.values = [
            { header: 'Gestionnaire', disabled: true },
            ...assistants.value.filter(el => el.role_name === 'gestionnaire'),
            { header: 'Assistants Direct', disabled: true },
            ...assistants.value.filter(el => el.role_name === 'assistant_direct')]
        }
        const indexPub = filters.value.findIndex(ele => ele.value === 'assistant_pub.code')
        if (indexPub > 0) {
          filters.value[indexPub].filter.values = assistants.value.filter(el => el.role_name === 'assistant_publication' || el.role_name === 'service_publications')
        }
      })

    const windowHeight = ref(window.innerHeight)
    const tableHeight = ref(window.innerHeight - 250)
    window.addEventListener('resize', () => {
      windowHeight.value = window.innerHeight
    })
    watch(windowHeight, () => {
      tableHeight.value = windowHeight.value - 250
    })

    return {
      tableHeight,
      item,
      items,
      tableColumns,
      searchQuery,
      totalItems,
      loading,
      options,
      isFormActive,
      isFormMultipleActive,
      selectedRows,
      snackBarMessage,
      isSnackbarBottomVisible,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      deleteDialog,
      confirmDelete,
      openDialog,
      openMultipleDialog,
      deleteItem,
      avatarText,
      fetchItems,
      formatDate,
      filters,
      downloadObject,

      // icons
      icons: {
        mdiSquareEditOutline,
        mdiFileDocumentOutline,
        mdiDotsVertical,
        mdiDeleteOutline,
        mdiPlus,
        mdiClose,
        mdiExportVariant,
        mdiAccountOutline,
        mdiPencilOutline,
      },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';

.fixed-table .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot input {
   text-align: center;
 }
.fixed-table .v-select__slot  .v-label {
  width: 100%;
   text-align: center;
 }
</style>
